module.exports = __webpack_public_path__ + "static/media/Edit.441ff324.svg";